import { Injectable, signal } from '@angular/core';
import { AbstractCategoryFormService } from '../../../common/category-details/abstract-category-form-service';
import {
  createEventCategoryAsync,
  findEventCategoryAsync,
  updateEventCategoryAsync,
} from '../../../../backend/main';
import type { CategoryDetailsFormValuesWithTopics } from '../../../common/category-details/category-details-form-with-topics';
import { CategoryDetailsFormWithTopics } from '../../../common/category-details/category-details-form-with-topics';
import type { CategoryDetailsForm } from '../../../common/category-details/category-details-form';

@Injectable()
export class EventsCategoryFormService extends AbstractCategoryFormService<CategoryDetailsFormValuesWithTopics> {
  readonly i18nPrefix = signal('PAGES.EVENT.CATEGORY');

  readonly findCategoryAsync = findEventCategoryAsync;
  readonly createCategoryAsync = createEventCategoryAsync;
  readonly updateCategoryAsync = updateEventCategoryAsync;

  createForm(): CategoryDetailsForm {
    return new CategoryDetailsFormWithTopics();
  }
}
